import {
  hasMeasuredPlane,
  type SolarPlaneFit,
} from '@payaca/helpers/solarPlaneFit';

export const compassLabel = (azimuthDegrees: number): string => {
  const points = [
    'North',
    'North-east',
    'East',
    'South-east',
    'South',
    'South-west',
    'West',
    'North-west',
  ];
  return points[Math.round((((azimuthDegrees % 360) + 360) % 360) / 45) % 8];
};

export const roofBearingLabel = (face: {
  azimuthDegrees: number;
  planeFit?: Pick<SolarPlaneFit, 'status'>;
}): string =>
  hasMeasuredPlane(face)
    ? compassLabel(face.azimuthDegrees)
    : 'Unknown bearing';
